import React from 'react';
import CancelIcon from '@material-ui/icons/Cancel';

const UnsuccessfulPayment = () => {
    return (
        <div className='payment'>
            <div className='payment__box' style={{textAlign:'center'}}>
                <CancelIcon className='fail'/>
                <br/>
                <h1>پرداخت ناموفق</h1>
            </div>
        </div>
    );
};

export default UnsuccessfulPayment;
